<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'about-01' },
})
</script>

<template>
  <section class="b2-about" :class="`variant-${variant}`">
    <div class="b2-about-image-wrap">
      <img :src="content.image.value" alt="" class="b2-about-img" />
      <div class="b2-about-badge">
        <strong>{{ content.badge_number.value }}</strong>
        <span>{{ content.badge_label.value }}</span>
      </div>
    </div>
    <div class="b2-about-text">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
      <p>{{ content.body_1.value }}</p>
      <p>{{ content.body_2.value }}</p>
      <ul class="b2-about-list">
        <li v-for="item in content.points.value" :key="item">✓ {{ item }}</li>
      </ul>
      <a href="#contact" class="b2-btn-primary">Work With Us</a>
    </div>
  </section>
</template>

<style scoped>
.b2-about { background: #f5f9f4; padding: 100px 40px; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; max-width: 1200px; margin: 0 auto; align-items: center; }
@media (max-width: 768px) { .b2-about { grid-template-columns: 1fr; gap: 40px; padding: 60px 20px; } }
.b2-about-image-wrap { position: relative; }
.b2-about-img { width: 100%; height: 500px; object-fit: cover; border-radius: 4px; }
.b2-about-badge { position: absolute; bottom: -24px; right: -24px; background: #4a8c3f; color: white; padding: 24px 28px; border-radius: 4px; text-align: center; box-shadow: 0 8px 32px rgba(74,140,63,.3); }
.b2-about-badge strong { display: block; font-family: 'Playfair Display', serif; font-size: 40px; line-height: 1; }
.b2-about-badge span { font-size: 13px; opacity: .85; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin-bottom: 16px; }
.b2-about-text p { font-size: 16px; color: #555; line-height: 1.75; margin-bottom: 16px; }
.b2-about-list { list-style: none; margin: 20px 0 32px; display: flex; flex-direction: column; gap: 10px; }
.b2-about-list li { font-size: 15px; color: #2d5c24; font-weight: 500; }
.b2-btn-primary { background: #4a8c3f; color: white; padding: 14px 32px; border-radius: 2px; text-decoration: none; font-size: 14px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; border: none; cursor: pointer; display: inline-block; }
.b2-btn-primary:hover { background: #3a6e30; }
.variant-about-02 .b2-about-image-wrap { order: 2; }
.variant-about-02 .b2-about-badge { right: auto; left: -24px; }
.variant-about-03 { position: relative; max-width: none; min-height: 680px; grid-template-columns: 1fr; overflow: hidden; }
.variant-about-03 .b2-about-image-wrap { position: absolute; inset: 0; }
.variant-about-03 .b2-about-img { height: 100%; border-radius: 0; filter: brightness(.38) saturate(.8); }
.variant-about-03 .b2-about-badge { right: 40px; bottom: 40px; }
.variant-about-03 .b2-about-text { position: relative; z-index: 1; max-width: 650px; margin-left: max(0px, calc((100% - 1120px) / 2)); color: white; }
.variant-about-03 .b2-section-title, .variant-about-03 .b2-about-text p, .variant-about-03 .b2-about-list li { color: white; }
@media (max-width: 768px) {
  .variant-about-02 .b2-about-image-wrap { order: 0; }
  .variant-about-02 .b2-about-badge { left: auto; right: 0; }
  .variant-about-03 { min-height: 720px; }
}
</style>
